import $ from "jquery";

import * as notificationBar from "notificationBar";

const message =
  "You're offline. Readlang needs an internet connection to work.";

/** Readlang needs the internet to work: says so while the user is offline */
export const show = () =>
  notificationBar.showMessage({
    message,
    above: true,
    time: 3600 * 1000,
    element: $("body"),
    // At the top of the window, however far down the page is scrolled
    css: { position: "fixed" },
  });

/** Clears the notice once the connection's back (but not another message) */
const hide = () => {
  if (notificationBar.isShowing(message)) {
    notificationBar.dismiss();
  }
};

/** Shows the notice as the connection drops, and clears it once it's back */
export const follow = () => {
  window.addEventListener("offline", show);
  window.addEventListener("online", hide);
};
